/*eslint complexity: off*/
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Input from '@material-ui/core/Input';

import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import InputSelectAsync from '~/components/Input/InputSelectAsync';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import PartnerRecord from '~/records/PartnerRecord';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { fetchCorporations } from '~/utils/fetchCorporations';

const attrName = (attr) => PartnerRecord.hummanAttributeName(attr);

function PartnerItem({ record, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  const handleType = event => handleChange({type: event.target.value});

  return (
    <>
      <Form onSubmit={onSubmit} >
        <Paper
          Icon={MonetizationOn}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={t('partner.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} md={10}>
                <GridContainer>
                  <GridItem xs={12} md={6}>
                    <InputControl
                      name={'name'}
                      value={record.get('name')}
                      label={attrName('name')}
                      required={true}
                      inputComponent={Input}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <InputControl
                      value={record.get('code')}
                      name={'code'}
                      label={attrName('code')}
                      required={record.get('type') === 'promo' ? true : false }
                      inputComponent={Input}
                      onChange={handleChange}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <InputControl
                      name={'corporation'}
                      label={attrName('corporation')}
                      value={record.get('corporation')}
                      inputComponent={InputSelectAsync}
                      onChange={handleChange}
                      InputProps={{
                        isClearable: false,
                        handleFetch: fetchCorporations,
                        createEnabled: false,
                        error: false,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12} md={2}>
                <RadioGroup aria-label="position" name="position" value={record.get('type')} onChange={handleType}>
                  <FormControlLabel
                    value="promo"
                    control={<Radio color='primary' />}
                    label="Promoção"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="supplier"
                    control={<Radio color='primary' />}
                    label="Parceiro"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="corporation"
                    control={<Radio color='primary' />}
                    label="Empresa"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

PartnerItem.propTypes = {
  record: PropTypes.instanceOf(PartnerRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

PartnerItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(PartnerItem));
